// @flow
import React from 'react'
import Slider from 'react-slick'
import styled from 'styled-components'
import media from '../../../../styles/media'

const Component = styled.div`
  overflow: hidden;
`

const ImgContainer = styled.div`
  cursor: move;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
  overflow: hidden;
  background-position: center;
  background-size: cover;
  width: 420px;
  height: 315px;

  ${media.mdUp} {
    width: 640px;
    height: 427px;
  }

  &:not(:first-child) {
    margin-left: 1px;
  }

  &:not(:last-child) {
    margin-right: 1px;
  }

  &:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
  }
`

type Props = {
  images: Array<string>
}

const ImageSlider = ({ images }: Props) => {
  const settings = {
    dots: false,
    infinite: false,
    focusOnSelect: true,
    adaptiveHeight: false,
    swipeToSlide: true,
    responsive: [
      { breakpoint: 576, settings: { slidesToShow: 1 } },
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 100000, settings: { slidesToShow: 3 } }
    ],
    prevArrow: (
      <button>
        <span className="fa fa-chevron-left" />
      </button>
    ),
    nextArrow: (
      <button>
        <span className="fa fa-chevron-right" />
      </button>
    )
  }

  return (
    <Component>
      <Slider {...settings}>
        {images.map((image, i) => (
          <ImgContainer
            key={i}
            style={{ backgroundImage: `url('${image}')` }}
          />
        ))}
      </Slider>
    </Component>
  )
}

export default ImageSlider



// WEBPACK FOOTER //
// ./src/views/Property/components/ImageSlider/index.js